import {LoadingButton} from '@mui/lab';
import {Box, Button} from '@mui/material';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {saveFile} from '../../../utils/file';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';
import ModalFixed from '../../common/ModalFixed';
import SnackbarMessages from '../../common/SnackbarMessages';
import {DateTimeRangeSelect} from '../../selectors/DateTimeRangeSelect';

interface Props {
  id?: number;
}

const HazardAIMachineLocationHistoryExportExcel = ({id}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);
  const [isOpened, setIsOpened] = useState(false);

  // Local state for the selected dates
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>(() => [
    dayjs().toDate(),
    dayjs().toDate(),
  ]);

  const openModal = () => {
    setIsOpened(true);
  };

  const fetchData = async () => {
    setIsOpened(false);
    setIsFetching(true);

    // Convert Date objects to YYYY-MM-DD strings
    const date_start = dateRange[0]
      ? dayjs(dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
      : undefined;
    const date_end = dateRange[1]
      ? dayjs(dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
      : undefined;

    try {
      const params = {
        export: 'excel',
        //asset_machine_id: id,
        date_start,
        date_end,
      };
      console.log(params);

      const resp = await API.get(
        `${apiBaseUrl}/hazard-ai/${id}/machine-location-history`,
        {
          params,
          responseType: 'blob',
        }
      );

      const fileDateStart = date_start ?? dayjs().format('YYYY-MM-DD HH:mm:ss');
      const fileDateEnd = date_end ?? dayjs().format('YYYY-MM-DD HH:mm:ss');

      saveFile(
        resp.data,
        `${id}_location_history_${fileDateStart}_${fileDateEnd}.xls`
      );
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_fd438893');
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          //fullWidth
          //size="small"
          variant="outlined"
          loading={isFetching}
          onClick={openModal}
        >
          Download History
        </LoadingButton>
      </Box>

      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <DateTimeRangeSelect
                value={dateRange}
                size="small"
                onChange={(value) => {
                  setDateRange(value as [Date | null, Date | null]);
                }}
              />

              <Button
                variant="contained"
                disabled={!dateRange[0] || !dateRange[1] || isFetching}
                onClick={fetchData}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default HazardAIMachineLocationHistoryExportExcel;
